import dayjs, { type Dayjs } from 'dayjs'
import { type FC, useEffect } from 'react'
import { calculateDuration } from 'screens/Rostering/RotaBuilder/common/utils'
import { OneOffTimeWindow } from '../../formComponents'
import type {
  ModalSectionProps,
  RotaPatternFormValues,
  RotaPatternModalType
} from '../utils'

export const OneOffTimeWindowSection: FC<
  ModalSectionProps & {
    type?: RotaPatternModalType
    shortTitle?: boolean
    disableStartTime?: boolean
    disableEndTime?: boolean
  }
> = ({
  type,
  shortTitle,
  formData,
  form,
  setFormData,
  disableStartTime,
  disableEndTime
}) => {
  const isFlexiType = formData?.flexiType

  const duration = +calculateDuration(
    dayjs(formData?.patternTimeWindow?.[0] as Dayjs | undefined).toDate(),
    dayjs(formData?.patternTimeWindow?.[1] as Dayjs | undefined).toDate()
  ).durationInMinutes

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-existing dependency list; changing when this re-runs needs behavioural review
  useEffect(() => {
    if (!shortTitle) form?.setFieldValue('plannedDuration', duration)
  }, [isFlexiType])

  const handleStartTimeChanged = (value?: string) => {
    setFormData?.((prev: RotaPatternFormValues) => ({
      ...prev,
      startTime: value
    }))
    form?.setFieldValue('startTime', value)
  }
  const handleEndTimeChanged = (value?: string) => {
    setFormData?.((prev: RotaPatternFormValues) => ({
      ...prev,
      endTime: value
    }))
    form?.setFieldValue('endTime', value)
  }

  return (
    <OneOffTimeWindow
      type={type}
      shortTitle={shortTitle}
      isFlexiType={isFlexiType}
      formData={formData}
      onEndTimeChanged={handleEndTimeChanged}
      onStartTimeChanged={handleStartTimeChanged}
      disableStartTime={disableStartTime}
      disableEndTime={disableEndTime}
    />
  )
}
